<template>
  <b-list-group-item class="d-flex align-items-center">
    <b-avatar
      src="/static/img/ic-user.png"
      class="avatar"
    />
    <span class="title mr-auto">
      {{ getTitle }}
    </span>
    <b-badge
      v-if="isCreatedbyOwner && (group.creator !== group.name)"
      @click="expell(group.id)"
    >
      <i class="far fa-trash-alt"></i>
    </b-badge>
    <div
      v-if="(group.creator === group.name)"
      title="Group Owner"
      v-b-tooltip.hover.right
    >
      <i class="fas fa-user-shield"></i>
    </div>
  </b-list-group-item>
</template>

<script>
import axios from 'axios'
import {eventBus} from '../../main'

export default {
  name: 'MembersMedia',
  props: {
    'group': Object
  },
  computed: {
    getTitle () {
      let title = this.group.name
      if (title) {
        return title
      }
      return '<Untitled>'
    },
    isCreatedbyOwner: function () {
      if (this.group.creator === this.$store.state.user.login) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    expell (groupId) {
      eventBus.$emit('MemberToBeExpelled', groupId)
    }
  }
}
</script>

<style lang="scss" scoped>
  #media-wrapper {
    width: 64px;
    height: 64px
  }
  .list-group-item {
    width: 260px;
  }
  .badge-secondary {
    color: red;
    background-color: white;
    font-size: 12pt;
    padding-left: 0;
    padding-right: 0;
    &:hover {
      cursor: pointer;
    }
  }
  .avatar {
    margin-right: 16px;
    &:hover {
      cursor: default;
    }
  }
  .title {
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/groups/MembersMedia.vue